(() => {
  const normalize = value => value.replace(/\u00a0/g, ' ').replace(/[ \t]+/g, ' ').replace(/ *\n */g, '\n').replace(/\n{3,}/g, '\n\n').trim();
  const textOf = node => {
    if (node.nodeType === 3) return node.textContent;
    if (node.nodeType !== 1) return '';
    if (/^(SCRIPT|STYLE|META)$/.test(node.tagName)) return '';
    if (node.tagName === 'BR') return '\n';
    return Array.from(node.childNodes, textOf).join('') + (/^(P|DIV|LI|H[1-6])$/.test(node.tagName) ? '\n' : '');
  };
  function parse(text) {
    const headings = /\b(Top(?:\s+Notes?)?|Heart(?:\s+Notes?)?|Middle(?:\s+Notes?)?|Base(?:\s+Notes?)?|Key\s+Notes?|Main\s+Notes?|Fragrance\s+Notes?|Notes|Scent\s+Profile|Fragrance\s+Style|Concentration|Story|Perfumer|Ingredients|Size|Set\s+Includes)\s*:/gi;
    const matches = Array.from(text.matchAll(headings));
    const notes = [], removals = [];
    matches.forEach((match, i) => {
      if (!/notes?|^(top|heart|middle|base)$/i.test(match[1])) return;
      let start = match.index + match[0].length;
      const next = matches[i + 1]?.index ?? text.length;
      while (start < next && /\s/.test(text[start])) start++;
      const newline = text.indexOf('\n', start);
      const end = newline >= start && newline < next ? newline : next;
      const value = text.slice(start, end).trim();
      if (!value) {removals.push([match.index, next]);return;}
      const key = /^top/i.test(match[1]) ? 'top' : /^(heart|middle)/i.test(match[1]) ? 'heart' : /^base/i.test(match[1]) ? 'base' : 'notes';
      notes.push({key, value});
      removals.push([match.index, end]);
    });
    let story = text;
    removals.reverse().forEach(([start, end]) => { story = story.slice(0, start) + story.slice(end); });
    story = normalize(story).replace(/^vibe\s*:\s*/i, '').replace(/(?:^|\n)Notes\s*(?=\n|$)/gi, '');
    const intro = story.split(/\n|\b(?:Scent Profile|Fragrance Style|Concentration|Story|Perfumer|Ingredients|Size|Set Includes)\s*:/i)[0].trim();
    let summary = intro.match(/^.*?[.!?](?:\s|$)/)?.[0]?.trim() || intro;
    if (summary.length > 230) summary = summary.slice(0, 220).replace(/\s+\S*$/, '') + '…';
    return {notes, story, summary};
  }
  function enhance(scope = document) {
    scope.querySelectorAll('[data-whiff-scent]:not([data-enhanced])').forEach(source => {
      const text = normalize(Array.from(source.childNodes, textOf).join(''));
      if (!text) return;
      const {notes, story} = parse(text);
      const summary = source.dataset.shortDescription || parse(text).summary;
      const content = document.createDocumentFragment();
      const summaryBox = document.createElement('div');
      summaryBox.className = 'whiff-scent-summary rte';
      if (source.dataset.descriptor) {
        const p = document.createElement('p'); p.className = 'whiff-descriptor';
        const strong = document.createElement('strong'); strong.textContent = source.dataset.descriptor;
        p.append(strong); summaryBox.append(p);
      }
      if (summary) {const p = document.createElement('p');p.className = 'whiff-short-description';p.textContent = summary;summaryBox.append(p);}
      if (notes.length) {
        const list = document.createElement('dl');list.className = 'whiff-notes';
        notes.forEach(note => {
          const row = document.createElement('div');
          const term = document.createElement('dt');term.textContent = source.dataset[note.key + 'Label'];
          const detail = document.createElement('dd');detail.textContent = note.value;
          row.append(term, detail);list.append(row);
        });
        summaryBox.append(list);
      }
      content.append(summaryBox);
      if (story && (story !== summary || notes.length)) {
        const details = document.createElement('details');details.className = 'whiff-scent-details';
        const label = document.createElement('summary');label.textContent = source.dataset.scentLabel;
        const body = document.createElement('div');body.className = 'whiff-full-story rte';
        story.split(/\n+/).filter(Boolean).forEach(line => {const p = document.createElement('p');p.textContent = line;body.append(p);});
        details.append(label, body);content.append(details);
      }
      source.replaceChildren(content);source.dataset.enhanced = 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
